// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"stepper-styles_containerVerticalStepper__jL0oV","verticalStepperSxElement":"stepper-styles_verticalStepperSxElement__J1SRN"};